import { CommonModule, IMAGE_CONFIG, IMAGE_LOADER, ImageLoaderConfig, NgOptimizedImage, isPlatformBrowser, isPlatformServer, provideImgixLoader } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild, makeStateKey } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  NguCarousel,
  NguTileComponent,
  NguCarouselConfig,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent
} from '@ngu/carousel';
import { CarouselItem, CarouselService } from './carousel.service';
import { RouterModule } from '@angular/router';
import { PrerenderDataService } from '../../../prerender-data.service';
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { ImgCComponent } from './img-c/img-c.component';
import { DomSanitizer } from '@angular/platform-browser';
import { APPHOST } from '../../../app.component';

const ngu = [
  NguCarousel,
  NguTileComponent,
  NguCarousel,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent
]
@Component({
  selector: 'app-home-carousel2',
  standalone: true,
  imports: [CommonModule, ngu, RouterModule, NgOptimizedImage, ImgCComponent],
  templateUrl: './home-carousel2.component.html',

  styleUrl: './home-carousel2.component.scss',
  providers: [
    // provideImgixLoader("https://www.softnetcomputers.lk/"),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        // ${config.width===undefined?500:config.width}
        return `https://www.softnetcomputers.lk/api/image/thumb/${config.width}/0.9/${config.src}`;
        // return `https://www.softnetcomputers.lk/?src=${config.src}&width=${config.width}`;
      },
    },
  ]
})
export class HomeCarousel2Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('carodiv')
  carodiv!: ElementRef;
  matrix = '';
  matrixArr = [' ', ...Array(10)].map((_, i) => String.fromCharCode(i + 48)) // Numbers (0-9)
    .concat([...Array(26)].map((_, i) => String.fromCharCode(i + 97))) // Lowercase letters (a-z)
    .concat([...Array(26)].map((_, i) => String.fromCharCode(i + 65))); // Uppercase letters (A-Z)



  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, all: 0 },
    // slide: 1,
    speed: 2000,
    point: {
      visible: true,

    },
    load: 1,
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
    interval: {
      timing: 4500,
      initialDelay: 0
    },
    loop: true

  };
  tiles: CarouselItem[] = [
    //   {
    //   id: '',
    //   image1: 'https://www.softnetcomputers.lk/assets/graphics/placeholder.png',
    //   heading: 'Softnet Computers',
    //   description: 'Our brands and products are of genuine quality and the services that we provide are of a premium touch. We understand the requirements of the customers and provide the best according to their respective needs. ',
    //   redirect: false,
    //   link: ''
    // }
  ];
  CAROUSEL = makeStateKey<any>('CAROUSEL');

  QUALITY = '0.2f'
  mobileQuery: MediaQueryList;
  showCarousel = false;
  private destroy$ = new Subject<void>();


  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);
  isNotMobile: boolean = false;
  size: string = 'XSmall';
  width: number = 300;

  constructor(private carouselService: CarouselService,
    private prerenderDataService: PrerenderDataService,
    private _changeDetectorRef: ChangeDetectorRef, private sanitizer: DomSanitizer,
    private media: MediaMatcher,
    private breakpointObserver: BreakpointObserver,
    @Inject(PLATFORM_ID) private platformId: Object) {
    // Only query matchMedia if on browser (safe — no DOM access)
    this.mobileQuery = isPlatformBrowser(this.platformId)
      ? media.matchMedia('(max-width: 600px)')
      : { matches: false } as any;

    if (isPlatformBrowser(this.platformId)) {
      this.width = window.innerWidth;
    }


  }

  loadData() {
    this.carouselService.getWebCarousels()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (w) => {
          this.prerenderDataService.setPreloadedData(this.CAROUSEL, w);
          this.tiles = w.map((value: CarouselItem, index: number) => {
            value.bg = this.getRandomBg(value, index);
            return value;
          });
          // detectChanges() forces an immediate synchronous CD pass on this
          // component subtree — needed for client-side navigation where the
          // HTTP response arrives outside the initial CD cycle.
          this._changeDetectorRef.detectChanges();
        },
        error: (err) => {
          console.error('[Carousel] Failed to load carousel data:', err);
        }
      });
  }
  getInnerWidth() {
    if (typeof window !== "undefined") {
      return window.innerWidth;

    }
    return 800
  }
  ngAfterViewInit(): void {
    //  this.width = this.carodiv!.nativeElement.offsetWidth;
    this.showCarousel = true;
    if (isPlatformServer(this.platformId)) {
      // this.carouselService.getWebCarousels().subscribe(w => {
      //   this.prerenderDataService.setPreloadedData(this.CAROUSEL, w)

      //   this.tiles = w.map((value: CarouselItem) => { value.bg = this.getRandomBg(); return value; })
      //   this._changeDetectorRef.detectChanges()
      // })
    }
  }
  ngOnInit(): void {
    // The route resolver ensures this data is preloaded before component initialization.
    // We can hydrate it synchronously, preventing any skeleton loader flashes on SSR or CSR.
    const cached = this.prerenderDataService.getPreloadedData(this.CAROUSEL);
    if (cached !== null && cached.length > 0) {
      this.tiles = cached.map((value: CarouselItem, index: number) => {
        value.bg = this.getRandomBg(value, index);
        return value;
      });
      // Force change detection just in case (useful during SSR)
      this._changeDetectorRef.detectChanges();
    } else {
      // Fallback if resolver didn't run or cache was cleared
      this.loadData();
    }

    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (isPlatformBrowser(this.platformId)) {
          this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
        }

        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.size = this.displayNameMap.get(query)!;
            this.isNotMobile = (
              this.size === 'Medium' ||
              this.size === 'Large' ||
              this.size === 'XLarge'
            );
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  urlAdjust(url?: string): string {
    if (url !== undefined && url !== null) {
      // url = url.replace('/image', '/image/thumb/640/' + this.QUALITY)
      url = url.replace('api/image/', '').replace('.png', '.webp')
      return url
    }
    return '';
  }

  urlAdjust1stIndex(url?: string, siz: number = 800): string {

    // if ( this.size === 'XLarge') {
    //   url = 'https://assets.softnetcomputers.lk/1x/' + url!.replace('api/image', '').replace('.png', '.webp')

    // }
    // if (this.size === 'Large' ) {
    //   url = 'https://assets.softnetcomputers.lk/2x/' + url!.replace('api/image', '').replace('.png', '.webp')

    // }
    // if (this.size === 'Small' || this.size === 'XSmall'|| this.size === 'Medium') {
    //   url = 'https://assets.softnetcomputers.lk/3x/' + url!.replace('api/image', '').replace('.png', '.webp')
    // }
    // return url!;
    url = APPHOST + '/' + url 

    if (url !== undefined && url !== null) {
      url = url.replace('/image', '/image/thumb/' + siz + '/' + (this.isNotMobile ? '0.5' : '1') + '/true').replace('.png', '.webp')
      // url = url.replace('api/image/', '')
      return url
    }
    return '';
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {

  }

  carouselPoints(url?: string) {
    if (url === undefined) {
      return url;
    }
    url = url.replace('/image', '/image/thumb/100/' + (this.isNotMobile ? '0.5' : '1') + '/true').replace('.png', '.webp')

  }

  getWidthImg(): number {
    if (this.size === 'XLarge') {
      return 800
      return 900;
    }
    else if (this.size === 'Large') {
      return 800
      return 850;

    }
    else if (this.size === 'Medium') {
      return 800
      return 800;

    }
    else if (this.size === 'XLarge') {
      return 800
      return 780;

    }
    else if (this.size === 'Small') {
      return 450;

    }
    else if (this.size === 'XSmall') {
      return 300;

    }
    return 800
  }
  linkAlter(link: string) {
    if (link === undefined) return ''
    if (link === null) return ''
    return link.split('.lk')[1].split('?')[0]
  }

  linkAlterParams(link: string) {
    if (link === undefined) return ''
    if (link === null) return ''
    if (!link.includes('softnetcomputers'))
      return link
    var d = decodeURIComponent(link);

    return d.split('.lk')[1]
  }


  link(item: CarouselItem) {
    if (item.link === undefined) {
      return false
    } if (item.link === null) {
      return false
    }
    if (item.link.length > 0) {
      return true
    }
    return false;

  }

  getSrc(i: string): string {
    var g: string = i.replace('/image', '/image/thumb/100/.9') + ' 100w, ' +
      i.replace('/image', '/image/thumb/200/.9') + ' 200w,' +
      i.replace('/image', '/image/thumb/400/.4') + ' 400w,' +
      i.replace('/image', '/image/thumb/700/.4') + ' 700w,' +
      i.replace('/image', '/image/thumb/1024/.4') + ' 1024w,';

    return g;

  }

  getWidth() {
    if (this.mobileQuery) {
      return '100vw'
    } else {
      return '100vw'
    }
  }

  getOptimisedDes(s: string) {

    const g = s.split(' ')
    let h = ''
    g.forEach(e => {
      if (e.length === 3) {
        h += ` <span class="text-[#ff4d06] " style="">${e}</span> `
      }

      else if (e.length === 5) {
        h += ` <span class="text-[#ff4d06] " style="">${e}</span> `
      }
      
      else {
        h += ` ${e} `
      }
    })


    return this.sanitizer.bypassSecurityTrustHtml(h!)

  }

  getRandomBg(item: CarouselItem, index: number): number {
    const idStr = item.id || String(index);
    const sum = idStr.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return sum % 12;
  }
  @HostListener('mouseenter')
  generateMatrix() {

    let t = ''
    for (var i = 0; i < 2000; i++) {
      t += this.matrixArr[(Math.floor(Math.random() * this.matrixArr.length))]
    }
    // for(var i=0;i<2000; i++){
    //   t+=t
    // }
    this.matrix = t;
  }

}
